(function () {
  if (typeof window === 'undefined') return;

  var MOBILE_QUERY = '(max-width: 749px)';
  /** Must match landing-page-custom-tweaks.css pipeline gallery `@media (max-width: 767px)`. */
  var PIPELINE_GALLERY_MOBILE = '(max-width: 767px)';

  function clearSocialProofMarquee() {
    document.querySelectorAll('[data-social-marquee-timer]').forEach(function (grid) {
      var raw = grid.getAttribute('data-social-marquee-timer');
      if (raw) window.clearInterval(parseInt(raw, 10));
      grid.removeAttribute('data-social-marquee-timer');
      grid.removeAttribute('data-social-marquee');
    });
  }

  function initSocialProofMarqueeMobile() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    var roots = document.querySelectorAll(
      'body[class*="customer-story-lp"] [id*="section_social_proof"], body.template-page-quiz-lp [id*="section_social_proof"]'
    );
    if (!roots.length) return;
    Array.prototype.forEach.call(roots, function (root) {
      var grid = root.querySelector('.gallery-grid');
      if (!grid || grid.getAttribute('data-social-marquee') === '1') return;
      var items = grid.querySelectorAll(':scope > .homepage-gallery-grid-item');
      if (items.length < 2) return;
      grid.setAttribute('data-social-marquee', '1');
      var idx = 0;
      var tick = function () {
        if (!window.matchMedia(MOBILE_QUERY).matches) return;
        idx = (idx + 1) % items.length;
        var el = items[idx];
        var left = el.offsetLeft - grid.offsetLeft;
        grid.scrollTo({ left: left, behavior: 'smooth' });
      };
      var timerId = window.setInterval(tick, 2600);
      grid.setAttribute('data-social-marquee-timer', String(timerId));
    });
  }

  function buildDots(scroller) {
    if (!scroller || scroller.dataset.dotsBound === '1') return;
    var slides = Array.prototype.filter.call(scroller.children, function (el) {
      return el.nodeType === 1;
    });
    if (slides.length < 2) return;

    // Avoid duplicate containers if re-running
    var existing = scroller.parentNode && scroller.parentNode.querySelector(':scope > .swipe-dots[data-for="' + (scroller.id || '') + '"]');
    if (existing) existing.parentNode.removeChild(existing);

    var dotsWrap = document.createElement('ul');
    dotsWrap.className = 'swipe-dots';
    if (scroller.id) dotsWrap.setAttribute('data-for', scroller.id);

    slides.forEach(function (_, idx) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'swipe-dots__dot';
      btn.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
      btn.addEventListener('click', function () {
        var target = slides[idx];
        if (!target) return;
        var slideLeft = target.offsetLeft - scroller.offsetLeft;
        var first = slides[0];
        var narrowStrip = !!(first && first.offsetWidth > scroller.clientWidth * 0.42);
        var desired = narrowStrip
          ? slideLeft - (scroller.clientWidth - target.offsetWidth) / 2
          : slideLeft;
        scroller.scrollTo({ left: Math.max(0, desired), behavior: 'smooth' });
      });
      li.appendChild(btn);
      dotsWrap.appendChild(li);
    });

    scroller.parentNode.insertBefore(dotsWrap, scroller.nextSibling);

    function updateActive() {
      var scrollerRect = scroller.getBoundingClientRect();
      var center = scrollerRect.left + scrollerRect.width / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, idx) {
        var r = slide.getBoundingClientRect();
        var slideCenter = r.left + r.width / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < bestDist) { bestDist = dist; bestIdx = idx; }
      });
      var dots = dotsWrap.querySelectorAll('.swipe-dots__dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === bestIdx);
      });
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active-slide', i === bestIdx);
      });
    }

    // Lock the scroller to the TALLEST slide so dots don't shift when swiping.
    // Split out of updateActive(): it forces two synchronous layouts and used to
    // run on every scroll frame and on every iOS URL-bar resize. Only writes
    // when the height actually changes, so the ResizeObserver settles.
    function lockHeight() {
      var prev = scroller.style.height;
      scroller.style.height = 'auto';
      var maxH = 0;
      slides.forEach(function (s) {
        var sh = s.scrollHeight || s.offsetHeight;
        if (sh > maxH) maxH = sh;
      });
      scroller.style.height = maxH ? maxH + 'px' : prev;
    }

    var layoutQueued = false;
    function scheduleLayout() {
      if (layoutQueued) return;
      layoutQueued = true;
      window.requestAnimationFrame(function () {
        layoutQueued = false;
        lockHeight();
        updateActive();
        centerActiveSlideIfStrip();
      });
    }

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { updateActive(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    var isPipelineGallery = !!(
      scroller.closest &&
      scroller.closest('[id*="pipeline_gallery_KrgAdb"],[data-wetheme-section-id*="pipeline_gallery_KrgAdb"]')
    );

    function isNarrowStrip() {
      var first = slides[0];
      if (!first || scroller.clientWidth < 8) return false;
      return first.offsetWidth > scroller.clientWidth * 0.42;
    }

    function centerSlideIndex(idx) {
      var target = slides[idx];
      if (!target || scroller.clientWidth < 8) return;
      var slideLeft = target.offsetLeft - scroller.offsetLeft;
      var desired = slideLeft - (scroller.clientWidth - target.offsetWidth) / 2;
      scroller.scrollLeft = Math.max(0, desired);
    }
    function centerFirstIfStrip() {
      if (!isPipelineGallery || !isNarrowStrip()) return;
      var first = slides[0];
      if (!first) return;
      centerSlideIndex(0);
      updateActive();
    }
    /** Re-center whichever slide is nearest mid-viewport (resize / layout) without jumping to slide 1. */
    function centerActiveSlideIfStrip() {
      if (!isPipelineGallery || !isNarrowStrip()) return;
      var scrollerRect = scroller.getBoundingClientRect();
      var mid = scrollerRect.left + scrollerRect.width / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, idx) {
        var r = slide.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) {
          bestDist = d;
          bestIdx = idx;
        }
      });
      var target = slides[bestIdx];
      if (target && isNarrowStrip()) centerSlideIndex(bestIdx);
      updateActive();
    }

    // iOS fires resize whenever the URL bar shows/hides during a vertical
    // scroll; only a width change can affect this horizontal carousel.
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      scheduleLayout();
    });
    if (window.ResizeObserver) {
      var slideSizes = new WeakMap();
      var ro = new ResizeObserver(function (entries) {
        var changed = false;
        entries.forEach(function (entry) {
          var w = Math.round(entry.contentRect.width);
          var h = Math.round(entry.contentRect.height);
          var last = slideSizes.get(entry.target);
          if (!last || last.w !== w || last.h !== h) changed = true;
          slideSizes.set(entry.target, { w: w, h: h });
        });
        if (changed) scheduleLayout();
      });
      slides.forEach(function (s) { ro.observe(s); });
    }
    // Run twice on init: once to pick the active slide, then once after layout settles
    lockHeight();
    updateActive();
    setTimeout(function () { lockHeight(); updateActive(); }, 50);

    centerFirstIfStrip();
    requestAnimationFrame(centerFirstIfStrip);
    setTimeout(centerFirstIfStrip, 50);
    setTimeout(centerFirstIfStrip, 320);

    scroller.dataset.dotsBound = '1';
  }

  function init() {
    var pipelineGrids = document.querySelectorAll(
      'body[class*="customer-story-lp"] [id*="pipeline_gallery_KrgAdb"] .gallery-grid,' +
        'body[class*="customer-story-lp"] [data-wetheme-section-id*="pipeline_gallery_KrgAdb"] .gallery-grid,' +
        'html body.template-page-quiz-lp [id*="pipeline_gallery_KrgAdb"] .gallery-grid,' +
        'body.template-page-quiz-lp [data-wetheme-section-id*="pipeline_gallery_KrgAdb"] .gallery-grid'
    );
    pipelineGrids.forEach(function (grid) {
      var quizLp = document.body.classList.contains('template-page-quiz-lp');
      var isQuizPipeline =
        quizLp &&
        grid.closest('[id*="pipeline_gallery_KrgAdb"],[data-wetheme-section-id*="pipeline_gallery_KrgAdb"]');
      if (isQuizPipeline) {
        buildDots(grid);
      } else if (window.matchMedia(PIPELINE_GALLERY_MOBILE).matches) {
        buildDots(grid);
      }
    });

    var mq = window.matchMedia(MOBILE_QUERY);
    if (!mq.matches) return;

    // Steps + Building Blocks rows (must match landing-page-custom-tweaks.css carousel selectors)
    var groupScrollers = document.querySelectorAll(
      'html body[class*="customer-story-lp"] div.group-block-content.layout-panel-flex.layout-panel-flex--row.mobile-direction-row,' +
        'html body[class*="customer-story-lp"] div.group-block-content.layout-panel-flex.layout-panel-flex--column.mobile-direction-row,' +
        'html body.template-page-quiz-lp [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--row.mobile-direction-row,' +
        'html body.template-page-quiz-lp [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--column.mobile-direction-row,' +
        'html body.template-index-homepage-v2 [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--row.mobile-direction-row,' +
        'html body.template-index-homepage-v2 [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--column.mobile-direction-row,' +
        'html body.template-index-homepage-v2-video [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--row.mobile-direction-row,' +
        'html body.template-index-homepage-v2-video [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--column.mobile-direction-row,' +
        'html body.template-index [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--row.mobile-direction-row,' +
        'html body.template-index [id*="section_three_steps"] div.group-block-content.layout-panel-flex.layout-panel-flex--column.mobile-direction-row'
    );
    groupScrollers.forEach(buildDots);

    var curatedSetScrollers = document.querySelectorAll(
      'html body.template-index-homepage-v2 .hpv2-sets__grid[data-hpv2-sets-carousel],' +
        'html body.template-index-homepage-v2-video .hpv2-sets__grid[data-hpv2-sets-carousel]'
    );
    curatedSetScrollers.forEach(buildDots);

    initSocialProofMarqueeMobile();
  }

  function reset() {
    clearSocialProofMarquee();
    document.querySelectorAll('.swipe-dots').forEach(function (el) { el.parentNode.removeChild(el); });
    document.querySelectorAll('[data-dots-bound="1"]').forEach(function (el) { delete el.dataset.dotsBound; });
  }

  /** Quiz-LP: "Build a Gift" must match sticky CTA (gift-sets), not #stack-quiz. */
  function fixQuizLpBuildAGiftLink() {
    if (!document.body.classList.contains('template-page-quiz-lp')) return;

    var giftBtn =
      document.querySelector('[data-quiz-lp-build-gift]') ||
      document.querySelector('.gift-callout__btn--ghost');
    if (!giftBtn) return;

    var href = '/pages/gift-sets';
    var stickyBtn = document.querySelector('[data-sticky-cta] a.sticky-cta__btn, .sticky-cta-section a.sticky-cta__btn');
    if (stickyBtn) {
      var stickyHref = stickyBtn.getAttribute('href');
      if (stickyHref && stickyHref !== '#' && stickyHref.indexOf('#stack-quiz') !== 0) {
        href = stickyHref;
      }
    }

    giftBtn.setAttribute('href', href);
  }

  function stripHeroVideoControls() {
    var vids = document.querySelectorAll(
      'body[class*="customer-story-lp"] [id*="hero_customer_story"] video,' +
        'body.template-page-quiz-lp [id*="hero_customer_story"] video'
    );
    vids.forEach(function (v) {
      v.removeAttribute('controls');
      v.controls = false;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('muted', '');
      v.muted = true;
      v.setAttribute('autoplay', '');
      v.setAttribute('loop', '');
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('disableremoteplayback', '');
      var p = v.play && v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });
  }

  function boot() {
    init();
    fixQuizLpBuildAGiftLink();
    stripHeroVideoControls();
    /* Sections can mount slightly after DOMContentLoaded; second pass picks up swipe rows + dots */
    setTimeout(function () {
      init();
    }, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on resize crossing breakpoint
  var lastIsMobile = window.matchMedia(MOBILE_QUERY).matches;
  var lastPipelineGalleryMobile = window.matchMedia(PIPELINE_GALLERY_MOBILE).matches;
  window.addEventListener('resize', function () {
    var nowMobile = window.matchMedia(MOBILE_QUERY).matches;
    var nowPipelineMobile = window.matchMedia(PIPELINE_GALLERY_MOBILE).matches;
    if (nowMobile !== lastIsMobile || nowPipelineMobile !== lastPipelineGalleryMobile) {
      lastIsMobile = nowMobile;
      lastPipelineGalleryMobile = nowPipelineMobile;
      reset();
      boot();
    }
  });

  // Re-init when Shopify theme editor re-renders sections
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      reset();
      boot();
    });
    document.addEventListener('shopify:section:reorder', function () {
      reset();
      boot();
    });
  }
})();